export default __webpack_public_path__ + "static/404-landscape-bf438fbfbae7849b8bc5d8a82e8ef5e8.jpg";